import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faLock } from '@fortawesome/free-solid-svg-icons';
import RenameLotDialog from '../../../Dialogs/RenameLotDialog';

interface LotNumberComponentProps {
    lotNumber: string,
    lotStatus: string,
    isLocked: boolean
}

function LotNumberComponent({ lotNumber, lotStatus, isLocked }: LotNumberComponentProps) {

    const { t } = useTranslation();

    const [showRenameLotButton, setShowRenameLotButton] = useState(false);
    const [showRenameLotDialog, setShowRenameLotDialog] = useState(false);

    return (
        <>
            <div title={t('LotDetails.Summary.LotNumber')}>
                <div className="d-flex me-3 align-items-center" onMouseOver={() => setShowRenameLotButton(true)} onMouseOut={() => setShowRenameLotButton(false)}>
                    <h3>{lotNumber}</h3>
                    {isLocked && <h4><FontAwesomeIcon icon={faLock} title={t('LotStatus.Locked')} className="ms-1 text-warning" /></h4>}
                    {lotStatus !== "Graded" &&
                        <FontAwesomeIcon icon={faPen} className="ms-3" onClick={() => setShowRenameLotDialog(true)} style={{ "opacity": showRenameLotButton ? "1" : "0" }} />
                    }
                </div>
            </div>
            <RenameLotDialog
                showDialog={showRenameLotDialog}
                closeDialog={() => setShowRenameLotDialog(false)}
            />
        </>
    );
}

export default LotNumberComponent;